import { render, staticRenderFns } from "./ViewerCurrentObjectives.vue?vue&type=template&id=7ce171ad"
import script from "./ViewerCurrentObjectives.vue?vue&type=script&lang=js"
export * from "./ViewerCurrentObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports